import { Image, Link, StyleSheet, Text, View } from '@react-pdf/renderer';
import QRCode from 'qrcode';
import { FunctionComponent, useEffect, useState } from 'react';
import { REFERRAL_URL_TYPE } from '../../../constants';
import { generateReferralURL } from '../../../helpers/ReferralUtils';
import { isNonEmptyString } from '../../../helpers/StringUtils';
import { ConnectInitializeUser } from '../../../store/StoreTypes';
import { colors } from '../../../theme/colors';
import { FontFamily } from './FontFamilies';

const CONTENT_WIDTH = 248;

type Props = {
  hcpUser: ConnectInitializeUser;
};

export const QRSection: FunctionComponent<Props> = (props) => {
  const { hcpUser } = props;
  const [imageSrc, setImageSrc] = useState('');
  const uniqueURL = generateReferralURL(hcpUser.referralHash, REFERRAL_URL_TYPE.QRCODE);

  useEffect(() => {
    generateQRCode(uniqueURL);
  }, []);

  async function generateQRCode(url: string) {
    try {
      const image = await QRCode.toDataURL(url, { type: 'image/png' });
      setImageSrc(image);
    } catch (err) {
      throw new Error(`Url to image conversion (base64) failed: ${err}`);
    }
  }

  function honorific() {
    switch (hcpUser?.profession) {
      case 'General Practitioner':
      case 'Gastroenterologist':
      case 'Naturopathic Doctor':
        return 'Dr.';
      default:
        return '';
    }
  }

  function shouldHideFirstName() {
    return hcpUser?.name.length > 15;
  }

  return (
    <View style={styles.container}>
      {isNonEmptyString(imageSrc) && (
        <View style={styles.QRcodeWrapper}>
          <Image source={imageSrc} cache={false} />
        </View>
      )}

      <Link style={styles.description} src={uniqueURL}>
        Scan the QR code or click here to accept your referral from{' '}
        <Text style={styles.helvetiaBold}>
          {honorific()}
          {shouldHideFirstName() ? '' : hcpUser?.name} {hcpUser?.lastName}
        </Text>{' '}
        and access your 25% discount to the Nerva program.
      </Link>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: CONTENT_WIDTH,
    backgroundColor: colors.xxLightGray,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
    padding: 15,
  },
  QRcodeWrapper: {
    width: 76,
    aspectRatio: 1,
    backgroundColor: colors.white,
  },
  description: {
    flex: 1,
    fontSize: 10.5,
    lineHeight: 1.5,
    textDecoration: 'underline',
    color: colors.black,
    overflow: 'hidden',
  },
  helvetiaBold: {
    fontFamily: FontFamily.HelveticaBold,
  },
});
